import { useState, useMemo } from "react";
import { resources } from "@constants/hardcoded-strings";
import { AXNUIThemingTabTypes } from "@enums/axnui-theming-tab-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { PageLevelTypes } from "@enums/page-level-types";
import {
    AXNUIContent,
    AXNUIContentCommonAsyncModal
} from "@iddataweb/idw-common-ui/types";
import { ThemingAsyncWaitingPageValidationErrors, ThemingFormContentValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingSubHeaderContainer } from "@containers/common/theming-sub-header-container/theming-sub-header-container";
import { ThemingFormSection } from "@containers/common/theming-form-section/theming-form-section";
import { ThemingFormContentAsyncModalTextsSection } from "../theming-form-content-tab-container/theming-form-content-async-modal-texts-section/theming-form-content-async-modal-texts-section";

type ThemingAsyncWaitingPageTabContainerProps = {
    isDisabled: boolean;
    validationErrors: ThemingAsyncWaitingPageValidationErrors;
    inheritedAXNUIContent: AXNUIContent;
    axnuiContent: AXNUIContent,
    pageLevel: PageLevelTypes;
    generatePreviewComponent: (currentTab: AXNUIThemingTabTypes) => React.ReactNode;
    updateAXNUIContentPropertyValue: (axnuiContent: AXNUIContent) => void;
};

export const ThemingAsyncWaitingPageTabContainer = (props: ThemingAsyncWaitingPageTabContainerProps) => {
    const {
        isDisabled,
        validationErrors,
        inheritedAXNUIContent,
        axnuiContent,
        pageLevel,
        generatePreviewComponent,
        updateAXNUIContentPropertyValue,
    } = props;

    const [labelWidth] = useState(LabelWidthTypes.EXTRA_SMALL);
    const [layout] = useState(LayoutTypes.COLUMN);

    const updateAXNUIContentCommonAsyncModalFieldValue = (key: keyof AXNUIContentCommonAsyncModal, value: string) => {
        const newPropertyValue: AXNUIContent = {
            ...axnuiContent,
            common: {
                ...axnuiContent.common,
                asyncModal: {
                    ...axnuiContent.common.asyncModal,
                    [key]: value
                }
            }
        };
        updateAXNUIContentPropertyValue(newPropertyValue);
    };

    const previewComponent = useMemo(() => {
        return generatePreviewComponent(AXNUIThemingTabTypes.ASYNC_WAITING_PAGE);
    }, [generatePreviewComponent]);

    return (
        <div>
            <ContentPageHeader title={resources.pages.verificationServiceDetails.tabs.theming.subTabs.asyncWaitingPage.title} />
            <ContentPageBody isMaxWidth={true}>
                <ThemingSubHeaderContainer description={resources.pages.verificationServiceDetails.tabs.theming.subTabs.asyncWaitingPage.description} />
                <ThemingConfigurationContainer>
                    <ThemingFormContainer>
                        <ThemingFormSection>
                            <ThemingFormContentAsyncModalTextsSection
                                inheritedAXNUIContent={inheritedAXNUIContent}
                                axnuiContent={axnuiContent}
                                isDisabled={isDisabled}
                                labelWidth={labelWidth}
                                layout={layout}
                                validationErrors={validationErrors as ThemingFormContentValidationErrors}
                                pageLevel={pageLevel}
                                showOnlyAsyncWaitingPageContent={true}
                                updateAXNUIContentCommonAsyncModalFieldValue={updateAXNUIContentCommonAsyncModalFieldValue}
                            />
                        </ThemingFormSection>
                    </ThemingFormContainer>
                    {previewComponent}
                </ThemingConfigurationContainer>
            </ContentPageBody>
        </div >
    );
};